/**
 *
 */
export function useKeyboardNavigation(): {
  findFirstEnabledTab: (tabs: HTMLElement[]) => number;
  handleKeydown: (
    event: KeyboardEvent,
    tabs: HTMLElement[],
    selectedIndex: number,
    onSelectTab: (index: number) => void,
  ) => void;
} {
  function findNextEnabledTab(tabs: HTMLElement[], currentIndex: number): number {
    for (let i = currentIndex + 1; i < tabs.length; i++) {
      if (!tabs[i].hasAttribute("disabled")) return i;
    }

    for (let i = 0; i < currentIndex; i++) {
      if (!tabs[i].hasAttribute("disabled")) return i;
    }
    return currentIndex;
  }

  function findPreviousEnabledTab(tabs: HTMLElement[], currentIndex: number): number {
    for (let i = currentIndex - 1; i >= 0; i--) {
      if (!tabs[i].hasAttribute("disabled")) return i;
    }

    for (let i = tabs.length - 1; i > currentIndex; i--) {
      if (!tabs[i].hasAttribute("disabled")) return i;
    }
    return currentIndex;
  }

  function findFirstEnabledTab(tabs: HTMLElement[]): number {
    const index = tabs.findIndex((tab) => !tab.hasAttribute("disabled"));
    return index !== -1 ? index : 0;
  }

  function findLastEnabledTab(tabs: HTMLElement[]): number {
    for (let i = tabs.length - 1; i >= 0; i--) {
      if (!tabs[i].hasAttribute("disabled")) return i;
    }
    return 0;
  }

  function handleKeydown(
    event: KeyboardEvent,
    tabs: HTMLElement[],
    selectedIndex: number,
    onSelectTab: (index: number) => void,
  ): void {
    const key = event.key;
    let newIndex = selectedIndex;

    switch (key) {
      case "ArrowLeft":
        newIndex = findPreviousEnabledTab(tabs, selectedIndex);
        event.preventDefault();
        break;
      case "ArrowRight":
        newIndex = findNextEnabledTab(tabs, selectedIndex);
        event.preventDefault();
        break;
      case "Home":
        newIndex = findFirstEnabledTab(tabs);
        event.preventDefault();
        break;
      case "End":
        newIndex = findLastEnabledTab(tabs);
        event.preventDefault();
        break;
    }

    if (newIndex !== selectedIndex) {
      onSelectTab(newIndex);
      const interactiveElement = tabs[newIndex]?.querySelector("button, a") as HTMLElement;
      interactiveElement?.focus();
    }
  }

  return {
    findFirstEnabledTab,
    handleKeydown,
  };
}
